<div class="table-container">
  <table>
    <thead>
      <tr>
        <th
          *ngFor="let index of columnList"
          [ngStyle]="{ width: index?.width || 'auto' }"
          [ngClass]="{ 'bg-gray-lighter': isDialogContent }"
        >
          <div class="header-span">
            <span>{{ index?.name || "Column" }}</span>
            <!-- <img
              *ngIf="index?.name && !index?.noFilterIcon"
              src="assets/images/tableSort.svg"
            /> -->
          </div>
        </th>
        <th [ngStyle]="{ width: '100px' || 'auto' }" *ngIf="menuFlag">
          <div class="header-span header-span-menu">
            <span>Action</span>
            <!-- <img src="assets/images/tableSort.svg" /> -->
          </div>
        </th>
      </tr>
    </thead>
    <tbody
      *ngIf="!isLoading && (tableData?.length || 0) > 0"
      cdkDropList
      (cdkDropListDropped)="drop($event)"
    >
      <tr
        [ngClass]="isDragDisabled ? '' : 'cdk-drag'"
        cdkDrag
        [cdkDragDisabled]="isDragDisabled"
        *ngFor="let item of tableData"
      >
        <td
          *ngFor="let column of columnList"
          [ngStyle]="{ width: column?.width || 'auto' }"
          [ngStyle]="column?.style"
        >
          <ng-container [ngSwitch]="column?.type">
            <!-- text -->
            <!-- <span
              *ngSwitchCase="'text'"
              [class.event]="column?.event"
              (click)="column?.event ? onAction(column?.event, item) : null"
              [title]="item | deepValue : column"
            >
              {{ item | deepValue : column }}
            </span> -->

            <!-- text -->
            <img
              *ngIf="!column.showAfterText && column.iconUrl"
              src="{{ column.iconUrl }}"
              style="margin-right: 12px"
            />
            <img
              *ngIf="column.avatarKey"
              src="{{item?.[column.avatarKey]}}"
              width="24"
              height="24"
              (error)="onImageAvtrError($event)"
              style="border-radius: 60px; margin-right: 8px"
            />
            <span
              *ngSwitchCase="'text'"
              [class.event]="column?.event"
              (click)="column?.event ? onAction(column?.event, item) : null"
              [title]="item | deepValue : column"
              [ngStyle]="getMergedStyle(item, column)"
            >
              <span class="px-1" *ngIf="column?.key === 'rank'">#</span
              >{{ item | deepValue : column }}
            </span>

            <img
              *ngIf="column.showAfterText && column.iconUrl"
              src="{{ column.iconUrl }}"
              style="margin-right: 12px"
              (click)="column?.event ? onIconurlclick.emit(item) : null"
              title="{{ column?.title }} "
              style="cursor: pointer; margin-left: 5px"
            />

            <!-- multipleTexts -->
            <span
              *ngSwitchCase="'multipleTexts'"
              [ngClass]="{ event: column?.event }"
              [ngStyle]="getMergedStyle(item, column)"
              (click)="column?.event ? onAction(column?.event, item) : null"
            >
              <span *ngIf="item[column.key]?.length">
                {{ item[column.key][0] }}
              </span>

              <div *ngFor="let line of item[column.key]?.slice(1)">
                {{ line }}
              </div>
            </span>

            <!-- boolean -->
            <span
              *ngSwitchCase="'boolean'"
              [class.event]="column?.event"
              (click)="column?.event ? onAction(column?.event, item) : null"
              [title]="
                (item | deepValue : column) === true ||
                (item | deepValue : column) === 'true'
                  ? 'True'
                  : 'False'
              "
            >
              {{
                (item | deepValue : column) === true ||
                (item | deepValue : column) === "true"
                  ? "True"
                  : "False"
              }}
            </span>

            <!-- date -->
            <span
              *ngSwitchCase="'date'"
              [class.event]="column?.event"
              (click)="column?.event ? onAction(column?.event, item) : null"
              [title]="item | deepValue : column"
            >
              {{ item | deepValue : column | date : "dd/MM/YYYY" }}
            </span>

            <!-- date -->
            <span
              *ngSwitchCase="'dateWithMonth'"
              [class.event]="column?.event"
              (click)="column?.event ? onAction(column?.event, item) : null"
              [title]="item | deepValue : column"
            >
              {{ item | deepValue : column | date : "MMM d, y" }}
            </span>

            <!-- Image -->
            <img
              *ngSwitchCase="'image'"
              [class]="column?.class ? column?.class : 'image'"
              [src]="item[column?.key]"
              [alt]="column?.name"
              (error)="handleBrokenImage($event)"
              (click)="
                column?.event ? onValueChange(column?.event, item) : null
              "
            />

            <!-- Link -->
            <a
              *ngSwitchCase="'link'"
              [href]="item[column?.key]"
              target="_blank"
              rel="noopener noreferrer"
              [class.event]="column?.event"
              [title]="item | deepValue : column"
            >
              Open Link
            </a>

            <!-- Toggle -->
            <mat-slide-toggle
              *ngSwitchCase="'toggle'"
              [(ngModel)]="item[column?.key]"
              (change)="onToggleChange($event, item)"
              class="custom-orange-toggle"
            >
            </mat-slide-toggle>

            <!-- Button -->
            <button
              *ngSwitchCase="'button'"
              [disabled]="column?.disabled || false"
              [class]="column?.class || ''"
              (click)="onAction(column.key, item)"
              [ngStyle]="{
                color: column?.color || 'black',
                'background-color': column?.backgroundColor || 'blue'
              }"
              mat-raised-button
            >
              {{ column?.label || "Click" }}
            </button>
            <div
              *ngSwitchCase="'iconButton'"
              (click)="onAction(column.key, item)"
            >
              <img
                [src]="column?.buttonIconUrl"
                [style]="{
                  height: column?.iconHeight,
                  width: column?.iconWidth
                }"
              />
            </div>
            <!-- STATUS -->
            <div
              *ngSwitchCase="'status'"
              class="status-wrapper"
              [ngStyle]="getStatusMergedStyle(item, column)"
              [title]="item | deepValue : column"
              (click)="column?.event ? onAction(column?.event, item) : null"
            >
              {{ item | deepValue : column }}
            </div>
            <!-- iconButton2 -->
            <div *ngSwitchCase="'iconButton2'">
              <img
                *ngIf="item[column.key]"
                [src]="column?.buttonIconUrl"
                [style]="{
                  height: column?.iconHeight,
                  width: column?.iconWidth
                }"
                (click)="onAction(column.key, item)"
                class="icon-btn"
              />
            </div>
            <!-- Default -->
            <span
              *ngSwitchDefault
              [class]="column?.event ? 'event' : ''"
              (click)="column?.event ? onAction(column?.event, item) : null"
              [title]="item[column?.key] || column?.value"
            >
              {{ item[column?.key] || column?.value || "-" }}
            </span>
          </ng-container>
        </td>
        <td *ngIf="menuFlag">
          <div
            class="menu-option-wrapper"
            *ngIf="getMenuOptions(item).length > 0; else emptyBox"
          >
            <mat-icon
              style="cursor: pointer"
              class="icon-image"
              [matMenuTriggerFor]="menu"
            >
              more_horiz
            </mat-icon>

            <mat-menu #menu="matMenu">
              <button
                mat-menu-item
                *ngFor="let option of getMenuOptions(item); trackBy: trackFn"
                (click)="onAction(option.event, item)"
              >
                <div class="table-menu-item">
                  <img *ngIf="option.iconPath" [src]="option.iconPath" />
                  <span [ngStyle]="option?.style">{{ option.key }}</span>
                </div>
              </button>
            </mat-menu>
          </div>

          <ng-template #emptyBox>
            <div style="text-align: center; cursor: not-allowed">
              <mat-icon class="icon-image">more_horiz</mat-icon>
            </div>
          </ng-template>
        </td>
      </tr>
    </tbody>
  </table>

  <ng-container #skeletonLoader *ngIf="isLoading">
    <div class="skeleten">
      <li
        *ngFor="let _ of [].constructor(skeletonRows)"
        class="skeleton-table d-flex w-100"
      >
        <div class="skeleton-table__cell-content col-12">
          <div class="skeleton-table__cell-line">
            <div class="moving-element"></div>
          </div>
        </div>
      </li>
    </div>
  </ng-container>
  <section *ngIf="!isLoading && (tableData?.length || 0) == 0">
    <div class="no-data">
      <span>No Data Found</span>
    </div>
  </section>
</div>
